<template>
  <b-card class="border-0 rounded">
    <b-row align-v="center" class="category-item justify-content-center text-center h-100 p-0">
      <b-col class="text-center m-auto align-items-center p-0" align-self="center">
        <img :src="image" class="category-img" :alt="alt"><br>
        <span class="category-title w-100">{{ text }}</span>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

export default {
  name: "C102",
  props:['image', 'text', 'alt'],
}
</script>

<style scoped>
.category-item .col {
  text-decoration: none;
  color: #212121;
}

.category-img {
  max-width: 80px;
  min-width: 80px;
  margin-bottom: 7px;
}

.category-title {
  font-size: 12px;
  font-weight: bold;
}
.card-body{
  padding: 5px;
}
</style>